module.exports = __webpack_public_path__ + "img/ic_upload_poa.c8ec309a.svg";